module.exports = __webpack_public_path__ + "img/logo8.25909902.png";